module.exports = __webpack_public_path__ + "img/explortaion_example_1.0cbcddcb.png";